import { addToCartByKey, removeFromCartByKey } from 'features/carrello/actions';
import { useCallback, useMemo } from 'react';
import { useEsito, useInfoEsito } from 'features/sport/hooks';

import classNames from 'classnames';
import styles from './ScommesseEsitoBase.module.scss';
import { toggleCarrello } from 'features/carrello/carrelloSlice';
import { useAmbienteContext } from 'context/Ambiente';
import { useAppDispatch } from 'lib/centralStore';
import { useIsInCart } from 'features/carrello/hooks';
import { useQuotaVariation } from 'hooks';
import { useTranslation } from 'hooks/useLingUI';
import useWindowSize from 'hooks/useWindowSize';

export type ScommesseEsitoBaseProps = {
  keyEsito: string;
  noAction?: boolean;
  classNameButton?: string;
  classNameContainer?: string;
  gtagAction?: () => void;
};

export const ScommesseEsitoBase = ({
  keyEsito,
  noAction,
  classNameButton,
  classNameContainer,
  gtagAction,
}: ScommesseEsitoBaseProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { isMobile } = useWindowSize();

  const { ambiente, pathScommessa } = useAmbienteContext();

  const maybeEsito = useEsito(keyEsito);
  const { quota, infoEsitoKey, isActive: isEsitoActive } = maybeEsito ?? {};

  const maybeInfoEsito = useInfoEsito(infoEsitoKey);
  const { descrizione, descrizioneTrKey } = maybeInfoEsito ?? {};

  const isActiveInCart = useIsInCart(keyEsito);

  const [isArrowVisible, isIncreasing, isDecreasing] = useQuotaVariation(maybeEsito);

  const { quotaValue, isIncreasingArrowVisible, isDecreasingArrowVisible } = useMemo(() => {
    return {
      quotaValue: isEsitoActive && quota !== 0 ? (quota! < 10 ? quota!.toFixed(2) : quota) : '-',
      isIncreasingArrowVisible: isEsitoActive && isIncreasing && isArrowVisible,
      isDecreasingArrowVisible: isEsitoActive && isDecreasing && isArrowVisible,
    };
  }, [isArrowVisible, isDecreasing, isEsitoActive, isIncreasing, quota]);

  const onCartToggleHandler = useCallback(() => {
    if (isActiveInCart) {
      dispatch(removeFromCartByKey({ esitoKey: keyEsito, ambiente, pathScommessa }));
    } else {
      dispatch(addToCartByKey({ esitoKey: keyEsito, ambiente, pathScommessa }));
    }

    dispatch(
      toggleCarrello({
        isOpen: true,
        isFullCart: isMobile ? false : true,
      })
    );
  }, [isMobile, keyEsito, isActiveInCart, ambiente, pathScommessa, dispatch]);

  if (!maybeEsito) {
    return null;
  }

  const esitoClickHandler = () => {
    if (typeof gtagAction === 'function') {
      gtagAction();
    }
    onCartToggleHandler();
  };

  return (
    <div className={classNames(styles.container, classNameContainer ?? '')}>
      <span className={styles.label}>
        {/* TODO : RESTORE : t(descrizioneTipoScommessaWithInfoAggTrKey, descrizioneTipoScommessaWithInfoAgg) */}
      </span>
      <span className={styles.labelEvento}>{descrizioneTrKey ? t(descrizioneTrKey, descrizione) : descrizione}</span>
      <button
        disabled={!isEsitoActive || noAction}
        className={classNames(styles.buttonQuota, classNameButton, {
          [styles.active]: isActiveInCart,
          [styles.noAction]: noAction,
        })}
        onClick={esitoClickHandler}
      >
        <span
          className={classNames(styles.quotaWrapper, {
            [styles.changed]: isIncreasingArrowVisible || isDecreasingArrowVisible,
            [styles.increasing]: isIncreasingArrowVisible,
            [styles.decreasing]: isDecreasingArrowVisible,
          })}
        >
          {quotaValue}
        </span>
      </button>
    </div>
  );
};
